setUserID